export const language = {
	fi: {
		TITLE: 'Helsingin Makkarapäivä',
		SUB_TITLE: 'Consectetur sint consequat ullamco fugiat laboris id amet sunt id nisi minim tempor incididunt dolore.'
	},

	en: {
		TITLE: 'Helsinki Sausage Festival',
		SUB_TITLE: 'Consectetur sint consequat ullamco fugiat laboris id amet sunt id nisi minim tempor incididunt dolore.'
	},
	event: [
		{ id: 1, from: '10', period: 'am', desc: 'Opening' },
		{ id: 2, from: '12', period: 'am', desc: 'Sausage contest begins' },
		{ id: 3, from: '5', period: 'pm', desc: 'Announcement of the winner' },
		{ id: 4, from: '6', period: 'pm', desc: 'Standup comedy show' },
		{ id: 5, from: '7', period: 'pm', desc: 'Closing' },
	],
	getEventAgenda: () => language.event,
}